import * as THREE from 'three'
import { TAIGA_KEYS } from '../../../content/assets.js'
import site from '../../../content/site.js'

/**
 * TAIGA — tools/blender/taiga.py (harf başına devrilebilen parça, konumlar dosyaya gömülü)
 * + altında harf setiyle yazılan alt satır (site.js → taiga.subtitle)
 */
export default class TaigaSection
{
    constructor(_options)
    {
        // Options
        this.resources = _options.resources
        this.objects = _options.objects
        this.materials = _options.materials
        this.blockText = _options.blockText
        this.x = _options.x
        this.y = _options.y

        // Set up
        this.container = new THREE.Object3D()
        this.container.matrixAutoUpdate = false

        this.setLetters()
        this.setSubtitle()
    }

    setLetters()
    {
        this.letters = TAIGA_KEYS.map((_key) =>
        {
            const name = `${_key.substring(0, 1).toUpperCase()}${_key.substring(1)}`

            return this.objects.add({
                base: this.resources.items[`taiga${name}Base`].scene,
                collision: this.resources.items[`taiga${name}Collision`].scene,
                offset: new THREE.Vector3(0, 0, 0),
                rotation: new THREE.Euler(0, 0, 0),
                shadow: { sizeX: 1.6, sizeY: 1.2, offsetZ: - 0.6, alpha: 0.4 },
                mass: 1.5,
                soundName: 'blockHeavy'
            })
        })
    }

    setSubtitle()
    {
        if(!site.taiga.subtitle)
        {
            return
        }

        // TAIGA satırının önünde, ortalı. Kamera ~32° yukarıdan baktığı için 0.8 m'lik harflerin
        // ekranda TAIGA'nın altına düşmesi için en az ~1.3 m ön mesafe gerekir; boşluk payıyla 2.6 m
        this.subtitle = this.blockText.add(site.taiga.subtitle, {
            x: this.x,
            y: this.y - 2.6,
            align: 'center',
            material: this.materials.items.taiga
        })
    }
}
